import React from 'react';
import { Icon } from './Icon.js';
export const IconPlateKnife = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21C16.0294 21 12 16.9706 12 12C12 7.02944 16.0294 3 21 3", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M21 16C18.7909 16 17 14.2091 17 12C17 9.79086 18.7909 8 21 8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M8 21V3H7C4.79086 3 3 4.79086 3 7L3 15H7.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPlateKnife.js.map